<template lang="pug">
	div
		Alerts(ref="Alerts")

		b-form(@submit.prevent='onSubmit')
			component(:is="field.widget" v-model="form[field.name]" v-for="field in formUser" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

			div
				b-button(variant='success' type='submit' block :disabled="isSending")
					b-spinner(small label="Small Spinner" v-if="isSending")
					span(v-else) Создать аккаунт
</template>
<script>
	import { mapState, mapActions } from 'vuex';

	import Alerts from '../../../components/Alerts'
	import modelUser from '@/store/models/modelUser'
	import formUser from '@/store/forms/formUser'

	import clearFormMixin from '@/MIXINS/clearForm'
	import formBackValidation from '@/MIXINS/formBackValidation'
	import collectFormData from '@/MIXINS/collectFormData'


	export default {
		name: 'formCreateUser',
		props: {
			_cbOK:    { type: Function, default: ()=>{}, required: false },
			_cbERR:   { type: Function, default: ()=>{}, required: false },
		},
		mixins: [
			clearFormMixin,
			formBackValidation,
			collectFormData,
		],
		components: {
			Alerts,
		},
		data: () => ({
			form: { ...modelUser },
			isSending: false,
			formUser,
			msg: {
				ok: 'Пользователь успешно создан!',
				err: '',
			}
			// online: true,
		}),
		computed: {
			...mapState(['page', 'users']),

			error(){ return this.users.post.error },
		},
		methods: {
			...mapActions(['postUser']),

			successFormHandler(response) {
				// before
				this.clearForm('form');
				this.$store.commit('setRegUserID', response.id);

				// main
				this.isSending = false;
				this.error
					? this.errorFormHandler(this.error)
					: this.$refs.Alerts.showAlert(this.msg.ok, 'success');
			},
			errorFormHandler(error) {
				this.isSending = false;
				this.$refs.Alerts.showAlert(error.non_field_errors ? error.non_field_errors[0] : this.msg.err, 'error')
			},
			onSubmit() {
				this.isSending = true;
				this.$store.dispatch('postUser', this.collectFormData(this.form))
					.then(this.successFormHandler).then(this._cbOK)
					.catch(this.errorFormHandler).catch(this._cbERR);
			},
		},
		beforeMount(){
			// window.addEventListener("offline", e => this.online = false );
			// window.addEventListener("online", e => this.online = true );
		}
	}
</script>
